//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseCreator.js";
import "../no/ObjectSelector.js";
import "../no/ObjectTypeSelector.js";
import "../no/ObjectSelector.js";
import "../no/ObjectTypeSelector.js";
let d=[[[0,"AutoCADRevision",1,0],[0,"CrossHatchMappingFile",1,0],[0,"DrawingList",1,0],[0,"ExportAs",1,0],[0,"ExportData",1,0],[0,"ExportFacesAs",1,0],[0,"ExportFrom",1,0],[0,"ExportScaleOption",1,0],[0,"ExportScaleValue",1,0],[1,"ExportSelectionBlock",0,"ObjectSelector",0],[0,"ExportSplinesAs",1,0],[0,"FileSaveFlag",1,0],[0,"FlattenAssembly",1,0],[0,"InputFile",1,0],[0,"LayerMask",1,0],[0,"LineFontMappingFile",1,0],[1,"ObjectTypes",0,"ObjectTypeSelector",0],[0,"OutputFileType",1,0],[0,"OutputTo",1,0],[0,"OverlappingEntities",1,0],[0,"SettingsFile",1,0],[0,"SurfaceDesignU",1,0],[0,"SurfaceDesignV",1,0],[0,"TextFontMappingFile",1,0],[0,"ViewEditMode",1,0],[0,"ViewList",1,0],[0,"WidthFactorMode",1,0]],[[["filename"],"SaveSettings",{},1,0]],[]];
SPLM.DxfdwgCreator = class extends SPLM.BaseCreator{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DxfdwgCreator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DxfdwgCreator.ExportFromOption = Object.freeze({
    "DisplayPart" : "DisplayPart", "ExistingPart" : "ExistingPart"});

SPLM.DxfdwgCreator.OutputFileTypeOption = Object.freeze({
    "Dxf" : "Dxf", "Dwg" : "Dwg"});

SPLM.DxfdwgCreator.ExportAsOption = Object.freeze({
    "TwoD" : "TwoD", "ThreeD" : "ThreeD", "Cgm" : "Cgm"});

SPLM.DxfdwgCreator.OutputToOption = Object.freeze({
    "Modeling" : "Modeling", "Drafting" : "Drafting"});

SPLM.DxfdwgCreator.ExportDataOption = Object.freeze({
    "Modeling" : "Modeling", "Drawing" : "Drawing"});

SPLM.DxfdwgCreator.AutoCADRevisionOptions = Object.freeze({
    "R12" : "R12", "R13" : "R13", "R14" : "R14", "R2000" : "R2000", "R2004" : "R2004", "R2005" : "R2005", "R2007" : "R2007", "R2010" : "R2010", "R2013" : "R2013", "R2018" : "R2018"});

SPLM.DxfdwgCreator.ExportScaleOptions = Object.freeze({
    "Default" : "Default", "BaseView" : "BaseView", "UserSpecified" : "UserSpecified"});

SPLM.DxfdwgCreator.WidthfactorMethodOptions = Object.freeze({
    "AutomaticCalculation" : "AutomaticCalculation", "UseSameAsNXAspectratio" : "UseSameAsNXAspectratio", "UseValueSpecifiedInMappingFile" : "UseValueSpecifiedInMappingFile", "ScaleNXAspectratioWithSpecifiedValue" : "ScaleNXAspectratioWithSpecifiedValue"});

SPLM.DxfdwgCreator.ExportFacesAsOptions = Object.freeze({
    "Facets" : "Facets", "PolylineMesh" : "PolylineMesh"});

SPLM.DxfdwgCreator.ExportSplinesAsOptions = Object.freeze({
    "Spline" : "Spline", "Polyline2D" : "Polyline2D", "Polyline3D" : "Polyline3D"});

export default SPLM;